<template>
    <div class="create-class-container">
        <el-dialog
                title="创建班级(自有生源)"
                :visible.sync="$store.state.addClassDialog"
                width="30%"
                :before-close="handleClose"
                :close-on-click-modal="clickModalClose"
                >
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
                <el-form-item label="班级名称" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="开课日期" prop="date">
                    <el-date-picker type="date" placeholder="选择日期" v-model="form.date" style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="上课时间" prop="time">
                    <el-time-picker
                            is-range
                            v-model="form.time"
                            :default-value="[new Date(), new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59)]"
                            style="width: 100%"
                            format="HH:mm"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围">
                    </el-time-picker>
                </el-form-item>
                <el-form-item label="课程周期" prop="cycle">
                    <el-checkbox-group v-model="form.cycle">
                        <el-checkbox-button label="0" name="cycle" value="0" style="width: 14%">周日</el-checkbox-button>
                        <el-checkbox-button label="1" name="cycle" value="1" style="width: 14%">周一</el-checkbox-button>
                        <el-checkbox-button label="2" name="cycle" value="2" style="width: 14%">周二</el-checkbox-button>
                        <el-checkbox-button label="3" name="cycle" value="3" style="width: 14%">周三</el-checkbox-button>
                        <el-checkbox-button label="4" name="cycle" value="4" style="width: 14%">周四</el-checkbox-button>
                        <el-checkbox-button label="5" name="cycle" value="5" style="width: 14%">周五</el-checkbox-button>
                        <el-checkbox-button label="6" name="cycle" value="6" style="width: 14%">周六</el-checkbox-button>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="课程次数" prop="count">
                    <el-input v-model="form.count"></el-input>
                </el-form-item>
                <p class="warn">
                    <span>提示:</span>
                    该页面创建的班级是自有生源班级，如需平台介绍生源，请先 <i @click="$router.push('/console/myProfile')">完善资料</i>
                    后前往 <i @click="$router.push('/console/lesson')">课程列表</i> 页建班级。
                </p>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="$emit('hideDialog')">取 消</el-button>
                <el-button type="primary" @click="createClass">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {saveLocal, loadLocal} from 'common/js/store.js';

    export default {
        name: "createClass",
        data () {
            const userInfo = loadLocal('userinfo');
            return {
                clickModalClose: false,
                id: userInfo.id,
                lessonInfo: null,
                rid: '',
                lessonId: '',
                teacherName: userInfo.uname,
                currentDate: new Date(),
                form: {
                    name: '',
                    date: '',
                    time: '',
                    cycle: [],
                    count: ''
                },
                rules: {
                    name: [
                        { required: true, message: '请输入班级名称', trigger: 'change' },
                        { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'change' }
                    ],
                    date: [
                        { required: true, message: '请选择开课日期', trigger: 'change' },
                    ],
                    time: [
                        { required: true, message: '请选择开课时间', trigger: 'change' },
                    ],
                    cycle: [
                        { required: true, message: '请选择开课周期', trigger: 'change' },
                    ],
                    count: [
                        { required: true, message: '请输入课程次数', trigger: 'change' },
                        { pattern: /^[1-9]$|^\d{2,3}$/, message: '课程次数为不能超过999的数字', trigger: 'change'}
                    ],
                }
            }
        },
        created() {
            this.querySelfClass();
        },
        methods: {
            createClass () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.addClass();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },

            handleClose () {
                this.$emit('hideDialog')
            },

            // 将课程信息存储在本地
            saveLessonInfo () {
                if (this.lessonInfo) {
                    saveLocal('lessoninfo',this.lessonInfo);
                }
            },

            // 查询课程列表
            queryLesson () {
                this.$http({
                    url: '/indexapp.php',
                    method: 'GET',
                    params: {
                        c: 'Lesson',
                        a: 'QueryLesson',
                        id: this.id,
                        queryrid: this.rid,
                        pageno: 1,
                        pagesize: 100
                    }
                }).then(res => {
                    const data = res.data;
                    if (data.code === 200) {
                        this.lessonInfo = data.list.filter(item => item.id == this.lessonId)[0];
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },

            // 查询是否存在自有课程
            querySelfClass () {
                this.$http({
                    url: '/indexapp.php',
                    method: 'GET',
                    params: {
                        c: 'Lesson',
                        a: 'QueryStudentSourceLesson',
                        id: this.id,
                    }
                }).then(res => {
                    const data = res.data;
                    if (data.code === 200) {
                        this.lessonId = data.list[0].id;
                        this.rid = data.list[0].rid;
                        this.queryLesson();
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },

            // 添加班级
            addClass () {
                Date.prototype.format = function(fmt) {
                    var o = {
                        "M+" : this.getMonth()+1,                 //月份
                        "d+" : this.getDate(),                    //日
                        "h+" : this.getHours(),                   //小时
                        "m+" : this.getMinutes(),                 //分
                        "s+" : this.getSeconds(),                 //秒
                        "q+" : Math.floor((this.getMonth()+3)/3), //季度
                        "S"  : this.getMilliseconds()             //毫秒
                    };
                    if(/(y+)/.test(fmt)) {
                        fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
                    }
                    for(var k in o) {
                        if(new RegExp("("+ k +")").test(fmt)){
                            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
                        }
                    }
                    return fmt;
                };

                const params = {
                    id: this.id,
                    rid: this.rid,
                    lessonid: this.lessonId,
                    classname: encodeURIComponent(this.form.name),
                    classcycle: this.form.cycle.sort((a, b) => a - b).toString(),
                    classmode: 1,
                    classmodename: '1对1',
                    democlass: 0,
                    discount: 0,
                    startdate: this.form.date.format('yyyy-MM-dd'),
                    starttime: this.form.time[0].format('hh:mm:ss'),
                    endtime: this.form.time[1].format('hh:mm:ss'),
                    totalnumber: this.form.count,
                    totalprice: 0,
                    unitpriceL: 0,
                    introduce: JSON.stringify([{text: this.teacherName + encodeURIComponent('老师邀请你上课')}])
                };

                this.$http({
                    url: '/indexapp.php?c=Lesson&a=AddClass',
                    method: 'GET',
                    params
                }).then(res => {
                    const data = res.data;
                    if (data.code === 200) {
                        this.$message({
                            message: '创建班级成功',
                            type: 'success'
                        });
                        this.$store.commit('setUpdateClassList');
                        this.$emit('hideDialog');
                        this.$refs['form'].resetFields();
                        this.form.time = '';
                        if (this.$route.path === '/console/lesson/class') {
                            const lessonInfo = loadLocal('lessoninfo'); // 读取本地lessoninfo与当前做比较
                            if (lessonInfo.id !== this.lessonInfo.id) { // 当前班级页不是自有生源时 刷新页面
                                this.saveLessonInfo();
                                location.reload();
                                return
                            }
                        }
                        this.saveLessonInfo();
                        this.$router.push({name: 'class'})
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },
        }
    }
</script>

<style lang="scss">
.create-class-container {
    .el-checkbox-button {
        &.is-focus {
           span {
               border-color: #dcdfe6;
           }
        }
        &.is-checked {
            span {
                border-color: #409EFF;
            }
        }
        span {
            display: inline-block;
            width: 100%;
            text-align: center;
            padding: 12px 0;
        }
    }
    .warn {
        line-height: 1.5;
        span {
            color: #F56C6C;
        }
        i {
            font-style: normal;
            &:hover {
                cursor: pointer;
                color: #F56C6C;
                text-decoration-line: underline;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/createClass/CreateClass.vue